import React from 'react';
import { Widget } from 'datastake-daf/dist/components';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';

export default function AnalysisWidget({
  children,
  title = null,
  className = null,
  loading = false,
  header = null,
  tooltip,
  filtersConfig,
  tabsConfig,
}) {
  return (
    <Widget
      className={formatClassname(['flex-1', className])}
      filtersConfig={filtersConfig}
      loading={loading}
      addedHeader={header}
      title={title}
      tooltip={tooltip}
      tabsConfig={tabsConfig}
    >
      {children}
    </Widget>
  )
}
